import useProducts from './useProducts';

export default useProducts;
